export const DOSSIER_OVERVIEW_SCHOOLS_RESOURCE = {
  key: 'DOSSIER_OVERVIEW_SCHOOLS_RESOURCE',
  table: {
    title: 'Scholen',
    emptyMessage: 'Er zijn momenteel geen scholen toegevoegd.',
    defaultSort: 'branch',
    dataLocation: '_embedded.static',
    disablePagination: true,
    fields: [
      { value: 'school', label: 'Naam school', show: true, order: 0 },
      { value: 'branch', label: 'Naam vestiging', show: true, order: 1 },
      { value: 'type', label: 'Niveau', show: true, order: 2 },
      { value: 'schoolPhone', label: 'Algemeen telefoonnummer school', show: true, order: 3 },
      { value: 'branchPhone', label: 'Telefoonnummer vestiging', show: true, order: 4 },
      { value: 'cityDistrict', label: 'Wijk', show: true, order: 5 },
      { value: 'cityDistrictManager', label: 'Wijkverantwoordelijke', show: true, order: 6 },
      { value: 'address', label: 'Adres vestiging', show: true, order: 7 },
      { value: 'director', label: 'Directeur', show: true, order: 8 }
    ]
  }
};
